import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { JSend } from '../../models/jsend.model';
import { SiloRealCredentials } from '../models/siloreal-credentials.model';

@Injectable({
  providedIn: 'root'
})
export class SiloRealService {

  private baseUrl = '/:apiBase/companies/:companyId/siloreal/credentials';

  constructor(
    private http: HttpClient
  ) { }

  public get(companyId: number): Observable<SiloRealCredentials> {
    const url = this.baseUrl.replace(':companyId', companyId.toString());

    return this.http.get<JSend<{
      credentials: SiloRealCredentials;
    }>>(url).pipe(map(response => plainToInstance(SiloRealCredentials, response.data.credentials)));
  }

  public save(companyId: number, credentials: SiloRealCredentials): Observable<SiloRealCredentials> {
    const url = this.baseUrl.replace(':companyId', companyId.toString());
    // Sin password, el back conserva la guardada
    const body = credentials.password
      ? { username: credentials.username, password: credentials.password }
      : { username: credentials.username };

    return this.http.put<JSend<{
      credentials: SiloRealCredentials;
    }>>(url, body).pipe(map(response => plainToInstance(SiloRealCredentials, response.data.credentials)));
  }
}
